import Record from './Record'

export default class CompanyBan extends Record {

	constructor (data) {
		super(data)

		return this._proxy
	}

	static async fetch (ban = null) {
		if (ban == null) {
			// Create record
			return new CompanyBan({
				ban: null,
				company_id: null
			})
		} else {
			// Load
			let data = await Anvil.REST.get(`/company_ban/${ban}`)
			if (!data) {
				data = {
					ban,
					company_id: null
				}
			}
			return new CompanyBan(data)
		}
	}

	static async delete (ban) {
		await Anvil.REST.delete(`/company_ban/${ban}`)
	}

	async commit () {
		await Anvil.REST.post(`/company_ban`, this._data)
	}
}
